import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import LoginPage from "../Components/LoginPage";

type Props = NativeStackScreenProps<RootStackParamList, "AuthGate">;

const AuthGateScreen: React.FC<Props> = ({ navigation }) => {
  return <LoginPage />;
};

export default AuthGateScreen;

